import { Navigate } from 'react-router-dom'
import { useTagsIndex } from 'app/components/tags-index/useTagsIndex'
import { TagsIndexComponent } from 'app/components/tags-index/TagsIndexComponent'
import { useUser } from 'app/utils'

export default function Index() {
  const user = useUser()
  const hookData = useTagsIndex()

  if (!user) return null
  const target = user.workspaceId ? `/settings/tags/contacts` : `/settings/tags/locations`
  return (
    <>
      <Navigate to={target} replace />
      <TagsIndexComponent {...hookData} />
    </>
  )
}
